// SPDX-License-Identifier: AGPL-3.0-or-later

export interface SpoilerRevealNotice {
	channelId: string | null;
}

type SpoilerRevealListener = (notice: SpoilerRevealNotice) => void;
const spoilerRevealListeners = new Set<SpoilerRevealListener>();

export function subscribeSpoilerReveal(listener: SpoilerRevealListener): () => void {
	spoilerRevealListeners.add(listener);
	return () => {
		spoilerRevealListeners.delete(listener);
	};
}

export function notifySpoilerReveal(notice: SpoilerRevealNotice): void {
	for (const listener of spoilerRevealListeners) {
		listener(notice);
	}
}
